module.exports = __webpack_public_path__ + "static/media/help2.cd5c9a3e.webp";